import React from 'react'
import imageUrl from '../images/image';
import { Typography, TextField } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from "react-router-dom";
import InputLabel from '@mui/material/InputLabel';
import { Link } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { GoogleAuthProvider } from "firebase/auth";
import GoogleButton from "react-google-button";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import Input from '@mui/material/Input';
import AccountCircle from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import FullPageLoader from "../FullPageLoader/FullPageLoader";
import { ref, get } from 'firebase/database'
import { setUserData, setUserDetails, setUserPresent, getCollegeName } from './userManagement';

const MainContainer = styled('div')({
    height: "100vh",
    display: 'flex',
});
const ImageHalf = styled('div')({
    flex: 1,
    background: `url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
});
const ContentHalf = styled('div')({
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'black',
    justifyContent: 'center',
    textAlign: 'start',
});
const GenerateButton = styled('button')({
    marginTop: '15px',
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    cursor: 'pointer',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    color: 'white',
    height: '50px',
    borderRadius: '10px',
    fontSize: '16px',
    "&:hover": {
        background: 'black',
        color: 'white'
    },
});

const SignLogIn = () => {
    const navigate = useNavigate();
    const [email, setEmail] = React.useState("")
    const [password, setPassword] = React.useState('');
    const [errorSama, setError] = React.useState("");
    const [showPassword, setShowPassword] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);


    const onLogin = (e) => {
        e.preventDefault();

        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                setIsLoading(true);
                const user = userCredential.user;
                setUserDetails(user);
                checkUserAvailable(user)
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setError(errorMessage)
                console.log(errorCode, errorMessage)
            });

    }

    const onGoogleSignIn = (e) => {
        e.preventDefault();
        const googleAuthProvider = new GoogleAuthProvider();
        signInWithPopup(auth, googleAuthProvider)
            .then((userCredential) => {
                const user = userCredential.user;
                setUserDetails(user);
                checkUserAvailable(user)
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                setError(errorMessage)
                console.log(errorCode, errorMessage)
            });

    }

    const checkUserAvailable = async (authUser) => {
        if (authUser) {
            const userUid = authUser.uid;
            const studentDetailsRef = ref(db, `${getCollegeName()}/New_Users/${userUid}`);

            try {
                const snapshot = await get(studentDetailsRef);
                if (snapshot.exists()) {
                    setUserPresent(true);
                    setUserData(snapshot.val());
                    navigate("/dashboard")
                } else {
                    setUserPresent(false);
                    navigate("/dashboard")
                }
            } catch (error) {
                console.error('Error checking student details data:', error);
            }
        }
    }

    return (
        <MainContainer>
            {isLoading && <FullPageLoader />}
            <ImageHalf />
            <ContentHalf>
                <Typography variant="h4" component="h2"
                    style={{
                        color: 'blueviolet', fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '40px',
                        padding: '40px', fontWeight: 'bold'
                    }}>
                    LOGO.
                </Typography>
                {errorSama && <Typography variant="danger" style={{ padding: '20px' }}>{errorSama}</Typography>}
                <FormControl variant="standard" style={{ padding: 10 }}>
                    <InputLabel htmlFor="input-with-icon-adornment" style={{ fontFamily: '"Poppins-Medium", Helvetica' }}>
                        Email
                    </InputLabel>
                    <Input
                        id="input-with-icon-adornment"
                        color="secondary"
                        label="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ width: '300px', height: '50px' }}
                        startAdornment={
                            <EmailIcon position="start" style={{ padding: '5px' }}>
                                <AccountCircle />
                            </EmailIcon>
                        }
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '295px' }} variant="standard">
                    <TextField
                        type={showPassword ? 'text' : 'password'}
                        variant='standard'
                        label="Create password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{ width: '300px', height: '50px' }}
                        size='medium'
                        required
                        InputProps={{
                            endAdornment: (
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            ),
                        }}
                    />
                </FormControl>
                <Typography style={{ padding: 20 }}>
                    Don't have an account? <Link to="/">Sign Up</Link>
                </Typography>
                <GoogleButton
                    className="g-btn"
                    type='light'
                    onClick={onGoogleSignIn}
                />
                <GenerateButton type='submit'
                    onClick={onLogin}>
                    Next
                </GenerateButton>


            </ContentHalf>
        </MainContainer>
    )
}

export default SignLogIn;